var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8232 4C12.8232 6.20914 11.0324 8 8.82321 8C6.61407 8 4.82321 6.20914 4.82321 4C4.82321 1.79086 6.61407 0 8.82321 0C11.0324 0 12.8232 1.79086 12.8232 4Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8232 4C16.8232 5.65685 15.4801 7 13.8232 7C12.1664 7 10.8232 5.65685 10.8232 4C10.8232 2.34315 12.1664 1 13.8232 1C15.4801 1 16.8232 2.34315 16.8232 4Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82321 4C6.82321 5.65685 5.48007 7 3.82321 7C2.16636 7 0.823214 5.65685 0.823214 4C0.823214 2.34315 2.16636 1 3.82321 1C5.48007 1 6.82321 2.34315 6.82321 4Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8233 8C16.2711 8.00005 17.252 10.4456 17.6202 11.916C17.7639 12.4899 17.3095 13 16.7179 13H14.3917C13.9886 11.4903 13.2088 9.77805 11.7013 8.7998C12.2434 8.32097 12.9371 8 13.8233 8Z",
    fill: "#575757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82368 8C4.70929 8.00011 5.40187 8.32144 5.94379 8.7998C4.43685 9.77817 3.6573 11.4906 3.25434 13H0.928168C0.336557 13 -0.116917 12.4899 0.0268012 11.916C0.395081 10.4456 1.37589 8 3.82368 8Z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82321 9C12.5319 9 13.4897 12.301 13.7371 14.0061C13.8164 14.5526 13.3755 15 12.8232 15H4.82321C4.27093 15 3.83005 14.5526 3.90935 14.0061C4.15673 12.301 5.11456 9 8.82321 9Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.def5ed6bdc0afc86025ae581ebb1a630.svg";
export { ForwardRef as ReactComponent };